import gql from "graphql-tag";

const APPLICATION_QUERY = gql`
  query Application($slug: String!) {
    applications(where: { slug: $slug }) {
      slug
      banner {
        url
      }
      banner_title
      banner_description
      title_2
      content_2
      image_one {
        url
      }
      title_one
      description_one
      image_two {
        url
      }
      title_two
      description_two
      image_three {
        url
      }
      title_three
      description_three
      image_four {
        url
      }
      title_four
      description_four
      image_five {
        url
      }
      title_five
      description_five
    }
  }
`;

export default APPLICATION_QUERY;
